import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center justify-center gap-4 p-8 text-center" };
const _hoisted_2 = { class: "max-w-md" };
const _hoisted_3 = { class: "text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2" };
const _hoisted_4 = { class: "text-gray-600 dark:text-gray-400" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardNoData',
    props: {
        title: {},
        message: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("svg", {
                    class: "w-16 h-16 text-gray-400 dark:text-gray-500",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    })
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1 /* TEXT */)
                ])
            ]));
        };
    }
});
